import { useCallback } from 'react'
import { useFocusEffect, useRouter } from 'expo-router'
import { useStore } from '../models'

export const useSubscriptionGuard = () => {
  const router = useRouter()
  const {
    memberships: { isSubscribed }
  } = useStore()

  useFocusEffect(
    useCallback(() => {
      if (!isSubscribed) {
        router.replace('/(root)/(tabs)')
      }
    }, [isSubscribed])
  )
}
